export const AGENCY_PHONE = "+33756904327";
export const AGENCY_PHONE_DISPLAY = "07 56 90 43 27";
export const AGENCY_EMAIL = "contact@pimpmyplace.fr";
export const AGENCY_ADDRESS = "24 Hameau des Rébénas, 84800 L’Isle-sur-la-Sorgue";
export const WHATSAPP_NUMBER = "33756904327";
export const GENERAL_WHATSAPP_MESSAGE = "Bonjour, je souhaite échanger au sujet d'un projet immobilier dans le Vaucluse.";

export const getWhatsAppUrl = (message) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;